import {action, observable} from 'mobx';
import projectStore from "../containers/main/project/store.js";
import {actions, AlertType, category, DragAction, DropType, events, LessonLibraryType, ModuleDragType, ProjectType} from "../constants/enums"
import {getNewLessonParams, isSchoolAdmin} from "../utils/userUtility";
import {translate} from '../utils/localizationUtility';

import dragShare from '../assets/images/drag-move-lesson.svg'
import appStore from "../containers/app/store";
import {isMobile} from "../utils/screenUtility";
import {customEvent} from "../utils/analyticsUtil";
import folderStore from "./FolderStore";
import mainStore from "../containers/main/store";


export const dragActions = {
    'add': {
        actionType: DragAction.Add,
        key: 'drag.action.add',
        icon: dragShare
    },
    'share': {
        actionType: DragAction.Share,
        key: 'drag.action.share',
        icon: dragShare
    },
    'move': {
        actionType: DragAction.Move,
        key: 'drag.action.move',
        icon: dragShare
    },
    'notAllowed': {
        actionType: DragAction.NotAllowed,
        key: 'drag.action.notAllowed',
        icon: dragShare
    }
}
export const TIME_TO_DRAG = 200;


class DragStore {
    @observable source = null;
    @observable target = null;
    @observable dropType = null;
    @observable dragAction = false;
    @observable disableDrag = isMobile();

    @action setSource = (source, type) => {
        console.log('setting source', source,type)
        this.source = source;
        this.type = type;
    }

    @action setTarget = (target, dropType) => {
        this.target = target;
        this.dropType = dropType;
    }

    @action setDisableDrag = (val) => {
        if (this.disableDrag !== val) {
            this.disableDrag = val;
        }
    }

    @action clear = () => {
        this.source = null;
        this.target = null;
        this.dropType = null;
        this.dragAction = false;
    }

    @action setDragActon = (val) => {
        this.dragAction = val;
    }

    @action handleLessonModuleDrop = async () => {
        // this.disableDrag = true;
        try {
            switch (this.type) {
                case ModuleDragType.Module:
                    customEvent(events.CustomEvent, {category: category.Timeline, action: actions.DropAction})
                    if (this.source && this.target && this.source.id) {
                        this.setDragActon(true);

                        let sourceModule = this.source;
                        let targetModuleId = this.target;

                        await projectStore.moveModuleEnqueue(sourceModule, targetModuleId);
                    }
                    break;
                case ModuleDragType.Lesson:
                    if (this.source && this.target && (this.source.id || this.source.parentProjectId)) {
                        this.setDragActon(true);
                        let lesson = this.source;
                        let targetModuleId = this.target;

                        await projectStore.moveLessonToModule(lesson, targetModuleId);
                        const module = projectStore.getModuleById(this.target)
                        if (module?.lessons) {
                            customEvent(events.CustomEvent, {
                                category: category.Timeline,
                                action: actions.DropAction,
                                label: `# of lessons in module ${module.lessons.length}`
                            })
                        }
                    }
                    break;
                default:
            }
        } catch (err) {
            console.log('error during module drop:', err);
        } finally {
            // runInAction(() => {
            //     this.disableDrag = false;
            // })
        }
    }

    getTarget = () => {
        switch (this.dropType) {
            case DropType.Folder:
                return folderStore.findFolder(this.target)
            case DropType.Library:
                return {name: translate(`lessonsLibrary.${this.target}`)};
            default:
                return this.target
        }
    }


    @action handleDrop = async () => {
        let target = this.getTarget();
        if (this.source && target && this.type) {
            switch (this.type) {
                case ModuleDragType.Module:
                case ModuleDragType.Lesson:
                    await this.handleLessonModuleDrop();
                    break;
                    // todo add library drag type instead of default
                default:
                    await this.handleLibraryDrop(target);
            }
        }

    }

    handleLibraryDrop = async (target) => {
        this.setDragActon(true);
        const dragAction = this.getDragAction(this.source, target, this.type)
        if (!dragAction || dragAction.actionType === DragAction.NotAllowed) {
            console.log('no action, or not allowed:', dragAction);
            appStore.createAlertFromMessageId(AlertType.Error, 'drag.action.notAllowed');
            return;
        }
        if (this.type === LessonLibraryType.MyLessons && dragAction === dragActions[DragAction.Share]) {
            customEvent(events.CustomEvent, {
                category: category.ShareLessonToSchoolLibrary
            });
        }else{
            customEvent(events.CustomEvent, {
                category: category.LessonLibrary,
                action: actions.DragAction,
                label: {action: dragAction.actionType, type: this.type}
            });
        }
        try {
            mainStore.toggleProgressLoader(true);
            let sourceLesson = this.source;
            let folder = target;
            let lesson = await projectStore.fetchProject(sourceLesson.id, true, true) || sourceLesson;
            let folderId;
            let sharedFolderId;
            let msgId;
            switch (dragAction.actionType) {
                case DragAction.Add:
                    delete lesson.id;
                    delete lesson.sharedFolderId;
                    delete lesson.schoolShare;
                    delete lesson.folderId;
                    if (folder.id) {
                        lesson.folderId = folder.id;
                        folderId = folder.id;
                    }
                    msgId = 'lessonsLibrary.card.add';
                    lesson = {...lesson, ...getNewLessonParams()};
                    break;
                case DragAction.Share:
                    if (folder?.id) {
                        sharedFolderId = folder.id;
                        folderId = folder.id;
                    }
                    lesson.sharedFolderId = sharedFolderId;
                    lesson.schoolShare = true;
                    msgId = 'lessonsLibrary.card.shared';
                    break;
                case DragAction.Move:
                    if (folder?.id) {
                        folderId = folder.id;
                    }
                    if (folder?.shared || this.type === LessonLibraryType.SharedLessons) {
                        lesson.sharedFolderId = folderId;
                    } else {
                        lesson.folderId = folderId;
                    }
                    msgId = 'lessonsLibrary.card.move';
                    break;
                default:
            }
            if (lesson.type === ProjectType.Global) {
                await projectStore.addLessonToLessonPlansNew(lesson, folderId, sharedFolderId, false);
            } else {
                await projectStore.saveProject(lesson.name, lesson, false, true, false, false);
            }
            let folderName = folder?.name;
            if (!folder?.id) {
                try {
                    folderName = translate(folder?.name);
                } catch (err) {
                }
            }
            appStore.createAlertFromMessageId(AlertType.Success, msgId, {lessonName: lesson?.name, folderName});
        } catch (err) {
            appStore.createAlertFromMessageId(AlertType.Error, 'drag.action.error');
            console.log('drag and drop error:', err);
        } finally {
            this.clear();
            mainStore.toggleProgressLoader(false);
        }
    }

    getDragAction = (lesson, folder, type) => {
        // don't allow moving lessons into Musico Library
        if(folder?.name === translate('lessonsLibrary.discover-lessons')){
            return dragActions[DragAction.NotAllowed];
        }
        if (type === LessonLibraryType.MyLessons) { // we are moving a lesson from my lessons to
            if (folder?.shared || folder?.name === translate('home.school.lessons')) {// to a shared folder
                if (lesson.schoolShare) { // don't allow moving already shared lessons
                    return dragActions[DragAction.NotAllowed];
                }
                return dragActions[DragAction.Share];
            }
            // to my library, it's always a move
            return dragActions[DragAction.Move];
        }
        if (type === LessonLibraryType.SharedLessons) { // we are moving a lesson from shared lessons
            if (!folder?.shared && folder?.name !== translate('home.school.lessons')) {
                return dragActions[DragAction.Add];
            }
            if (!isSchoolAdmin()) {
                return dragActions[DragAction.NotAllowed];
            }
            if (folder?.shared || folder?.type === LessonLibraryType.SharedLessons) {// to a shared folder
                return dragActions[DragAction.Move]
            }

            return dragActions[DragAction.Share]
        }

        if (type === LessonLibraryType.DiscoverLessons) {
            // don't allow move Musico Lessons into shared School Library
            if (folder?.shared || folder?.name === translate('home.school.lessons')) {
                return dragActions[DragAction.NotAllowed];
            }
            return dragActions[DragAction.Add];
        }
    }
}


const dragStore = new DragStore();
export default dragStore;

